import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';

export type PortfolioLogoType = 'mini' | 'wide';
export type PortfolioLogoTheme = 'light' | 'dark';

export interface PortfolioLogoChange {
  superAdminId: string;
  logoType: PortfolioLogoType;
  logoTheme: PortfolioLogoTheme;
}

@Injectable({
  providedIn: 'root',
})
export class PortfolioSettingsService {
  private readonly brandingBaseUrl = `${environment.image_server}/portfolio-branding`;
  private readonly brandingChangedSubject = new Subject<PortfolioLogoChange>();
  public readonly brandingChanged$ = this.brandingChangedSubject.asObservable();

  constructor(private http: HttpClient) {}

  public getLogoUrl(
    superAdminId: string, 
    logoType: PortfolioLogoType, 
    logoTheme: PortfolioLogoTheme = 'light',
    cacheBust = Date.now()
  ): string {
    return `${this.getLogoEndpoint(superAdminId, logoType, logoTheme)}?t=${cacheBust}`;
  }

 private getLogoEndpoint(
    superAdminId: string,
    logoType: PortfolioLogoType,
    logoTheme: PortfolioLogoTheme = 'light',
  ): string {
    const endpointLogoType = logoTheme === 'dark' ? `${logoType}-monochrome` : logoType;
    return `${this.brandingBaseUrl}/${endpointLogoType}/${encodeURIComponent(superAdminId)}`;
  }
}
